<ndt-edit-presence-credentials-view
   [callState]="callState | async"
   [form]="form"
   (formCanceled)="onCloseClick()"
   (formSubmitted)="onCreate()"
>
</ndt-edit-presence-credentials-view>
